<!--
 * @Author: your name
 * @Date: 2022-02-28 18:00:38
 * @LastEditTime: 2022-10-25 10:52:41
 * @LastEditors: pyx 3245266940@qq.com
 * @Description: 合同 —— 实名认证 —— 认证方式 —— 手机号认证
 * @FilePath: \wx-front\src\views\contract\realNameAuthentication.vue
-->
<template>
<div class="wrap">
    <img src="../../assets/static/contract/phoneAuthentication.svg" class="topImg" alt="">
    <div class="fontScN8 fontH1 title">请输入本人信息，进行手机号认证</div>
    <div class="fontScN6 fontH3 tips">请输入本人正确且有效的信息</div>
    <div class="inputName fontScN6 fontH2">姓名</div>
    <div class="inputBox borderScN4 fontH2">
        <input
            class="telInput "
            ref="name"
            placeholder="请输入姓名"
            v-model="name"
          />
    </div>
    <div class="inputName fontScN6 fontH2">证件号</div>
    <div class="inputBox borderScN4 fontH2">
        <input
            class="telInput "
            placeholder="请输入证件号"
            v-model="certificateNo"
            ref="certificateNo"
          />
    </div>
    <div class="inputName fontScN6 fontH2">手机号</div>
    <div class="inputBox borderScN4 fontH2">
        <input
            type="tel"
            class="telInput "
            maxlength="11"
            placeholder="请输入手机号"
            v-model="phone"
            ref="phone"
          />
    </div>
    <div class="inputName fontScN6 fontH2">短信验证码</div>
    <div class="inputBox borderScN4 fontH2 rowJbAc">
        <input
            type="tel"
            class="codeInput "
            placeholder="请输入短信验证码"
            maxlength="6"
            v-model="code"
            ref="code"
          />
          <div class=" fontH3 codeBtn" :class="[(!isSendCode) ?' fontMcA1':'fontScN4']" @click="sendCode">{{ isSendCode ? `重发 ${awaitSec}s` : "发送验证码" }}</div>
    </div>
    <div class="seeBtnBox rowJcAc">
        <div class="seeBtn fontH3 bgcMcA1 rowJcAc fontScW"  @click="startCertification()">开始短信认证</div>
    </div>
</div>
</template>

<script>
import {postSendVerifyCodeAPI,postRealNameAuthenticationAPI} from "../../utils/api/api";
export default {
  data() {
    return {
       name:'',
       certificateNo:'',
       phone:'',
       code:'',
       awaitSec: 60, //计算再次获取验证码的倒计时
       timer: null, //获取验证码的定时器
       isSendCode: false, // 是否发送验证码

    };
  },
   computed: {
    },
    watch: {
    },
  created() {
  },
  mounted() {
  },
  beforeRouteLeave(to, from,next) {
      console.log('beforeRouteLeave')
    // 在导航离开渲染该组件的对应路由时调用
    // 与 `beforeRouteUpdate` 一样，它可以访问组件实例 `this`
    if(this.timer) {
        clearInterval(this,this.timer)
        this.isSendCode = false
    }
    next()
  },
  methods: {
    //进去合同签署页面
    startCertification() {
        if(this.checkMust()) {
            var obj = {
                authenticationMethod: 1, // 1: 手机号认证
                realName: this.name, 
                idCard: this.certificateNo,
                phone: this.phone,
                verifyCode: this.code
            }
            postRealNameAuthenticationAPI(obj).then(res => {
                if(res.resultCode == 200) {
                    this.$common.setCache('isRealName',1)
                    this.$router.push('/certificationPassed')
                }else {
                    this.$toast(res.resultStr)
                }
            })
        }
        
    },
    // 必填校验
    checkMust() {
        if(!this.name) {
            this.$toast('请输入姓名');
            this.$refs.name.focus()
            return false
        }else if(!this.$common.checkIdNumber(this.certificateNo)) {
            this.$toast('请输入正确的证件号');
            this.$refs.certificateNo.focus()
            return false
        }else if(!this.$common.checkPhone(this.phone)) {
            this.$toast('请输入正确的手机号');
            this.$refs.phone.focus()
            return false
        }else if(!this.code) {
            this.$toast('请输入短信验证码');
            this.$refs.code.focus()
            return false
        }
        return true
    },
    sendCode(){
        if(this.isSendCode) return
      
      if(!this.$common.checkPhone(this.phone)) {
            this.$toast('请输入正确的手机号');
            this.$refs.phone.focus()
            return false
        }
        this.isSendCode = true
        postSendVerifyCodeAPI({phone: this.phone}).then(res => {
            if (res.resultCode == 200) {
                this.isSendCode = true
                this.timer = setInterval(() => {
                    if (this.awaitSec == 1) {
                        clearInterval(this.timer)
                        this.awaitSec = 60
                        this.isSendCode = false
                    }
                    this.awaitSec = this.awaitSec - 1
                }, 1000)
            } else {
                this.isSendCode = false
                this.$toast(res.resultStr)
            }
        })
    }
  },
};
</script>
<style lang="scss" scoped>
.wrap {  
background: #fff;
height: 100%;
font-size: 14px;
padding: 0.24rem 0.16rem 0.08rem 0.16rem;
box-sizing: border-box;
}
.seeBtnBox{
    width: 100%;
    // height: 64px;
    position: fixed;
    bottom: 0;
    left: 0;
    background: #FFFFFF;
    padding: 8px 16px 8px 16px;
    box-sizing: border-box;
}
.seeBtn{
    width: 100%;
    height: 48px;
    border-radius: 6px;
}

.topImg{
    width: 0.5rem;
    height: 0.5rem;
}
.title{
    margin: 16px 0 6px 0;
}
.tips{
    margin-bottom: 16px;
}
.inputName{
    margin-bottom: 8px;
    margin-top: 12px;
}
.inputBox{
    width: 100%;
    padding-bottom: 16px;
    box-sizing: border-box;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    display: flex;
    input{
        width: 100%;
    }
    input::input-placeholder {
        color: #C8C9CC;
    }
    input::-webkit-input-placeholder {
        color: #C8C9CC;
    }
    input::-moz-input-placeholder {
        color: #C8C9CC;
    }
    input:-moz-input-placeholder {
        color: #C8C9CC;
    }
    input::-ms-input-placeholder {
        color: #C8C9CC;
    }
}
.codeInput{
    flex: 1;
}
</style>
